import axios from "axios";
import { baseURL } from "./EndPoint";

const axiosInstance = axios.create({
     baseURL: baseURL,
     withCredentials: true
});

export const axiosPrivate = axios.create({
    baseURL: baseURL,
    withCredentials: true
});

export default axiosInstance;